import { useContext } from 'react'
import { Grid, Typography } from '@mui/material'
import ReferralCard from './referralCard';
import Referral from '../../right-panel/referral/referral';
import custom from '../../../styles/mui/szVariables.json'
import { 
    sidePanelIcon
  } from '../../../components/common/iconPaths'
import { 
    DataContext, 
    DataDispatchContext 
} from '../../../contexts/data/dataContext'
import { analyticsCta, analyticsDomain } from '../../../services/constants'
import { sendClickAnalytics } from '../../common/util/util'

export default function PromoCards() {
    const data = useContext(DataContext)
    const dispatch: any = useContext(DataDispatchContext)

    const handleReferral = () => {
        window.scrollTo(0,0)
        dispatch({
            type: 'setRightPanel',
            rightPanel: <Referral key="referral"/>
        })
        sendClickAnalytics('/dashboard', {
              domain: analyticsDomain.dashboard,
              name: analyticsCta.tileReferFriend,
              metadata: {},
            })
    }

    if(!data?.dashboard?.cards) return null

    return (
        <>
        <Grid container id="promoCards" 
            direction="row" 
            justifyContent="flex-end" 
            width= "100%"
            px={custom.spacing.md}
            pt={custom.spacing.sm}
            >
            <Grid item xs={12} sm={12} md={12} lg={12} 
                width="100%" >
                <Typography 
                    variant="szHeading.Bold.Small" >
                        For you
                </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} 
                width="100%" 
                mt={custom.spacing.xs}>
                <ReferralCard id="referral" 
                    handleCardClick={handleReferral}
                    content={{
                        hoverIcon: sidePanelIcon,
                        icon: '/images/ReferIcon.svg',
                        title: 'Refer-a-Friend',
                        buttonText: 'Refer now',
                        desc: `Help a friend switch to solar and get rewarded. 
                            Share your unique code and earn $1,000 for each person 
                            who installs a solar energy system with us.`,
                    }} />
            </Grid>
        </Grid>
        </>  
    )
}